import { isPlatformServer } from '@angular/common';
import {
  Injectable,
  Inject,
  Optional,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';

@Injectable()
export class SsrResponseService {
  protected _platformId = inject(PLATFORM_ID);

  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  constructor(
    @Optional() @Inject(RESPONSE) private _response: Response | null
  ) {}

  get response(): Response | null {
    return this._response;
  }
}
